import { render, staticRenderFns } from "./isLogoIcon.vue?vue&type=template&id=2d2c64f8&"
import script from "./isLogoIcon.vue?vue&type=script&lang=js&"
export * from "./isLogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports